import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { LoadshiftSiteStatsBackend } from './loadshift-site-stats.backend';
import { loadshiftSiteStatsReducer } from './loadshift-site-stats.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('loadshiftSiteStats', loadshiftSiteStatsReducer),
    BackendModule.forFeature('loadshiftSiteStats', LoadshiftSiteStatsBackend),
  ],
})
export class DatastoreLoadshiftSiteStatsModule {}
